module.exports = __webpack_public_path__ + "img/static-texas2@2x.7e59d33c.png";